// extracted by mini-css-extract-plugin
module.exports = {"cell":"style__cell__5F0Z6","icon":"style__icon__7gyEi"};